import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import {ClinicInfoSettingsTypes} from '@/src/profile/accountSettings/containers/types/ClinicInfoSettingsTypes';

interface requestUpdateClinicBodyTypes {
  clinic: {
    organization_name: string;
    email: string;
    slug: string;
    website: string;
  };
}

const requestUpdateClinicInfo = (
  clinicId: number,
  values: ClinicInfoSettingsTypes
): Promise<any> => {
  const body: requestUpdateClinicBodyTypes = {
    clinic: {
      organization_name: values.clinicName,
      email: values.email,
      slug: values.userName,
      website: values.website,
    },
  };

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/clinics/clinics/${clinicId}`,
    body,
  });
};

export default requestUpdateClinicInfo;
